import {fork} from 'redux-saga/effects'
import locationSagas from './location-async'
import outletSagas from './outlet-async'
import searchSagas from './search-async'
import { updateCounterClickedTimeTask } from './accessory-async'
import {
  actionTypes as locationTypes,
  actionCreators as locationActions,
  selectors as locationSelectors,
} from './location'

import {
  actionTypes as environmentTypes,
  actionCreators as environmentActions,
  selectors as environmentSelectors,
} from './environment'

import {
  actionTypes as accessoryTypes,
  actionCreators as accessoryActions,
} from './accessory'

/** Root saga for state side effect management.
 * https://redux-saga.github.io/redux-saga/docs/introduction/index.html
 * */
function* rootSagas() {
  yield [
    fork(locationSagas),
    fork(outletSagas),
    fork(searchSagas),
    fork(updateCounterClickedTimeTask)
  ]
}

export {
  rootSagas,
  locationTypes,
  locationActions,
  locationSelectors,
  environmentTypes,
  environmentActions,
  environmentSelectors,
  accessoryTypes,
  accessoryActions,
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js